/**
 *
 */
export default function getAppURL(product = null) {
  return product ? `https://${product}.buffer.com` : null
}
